import React from 'react';

const PendingDelete = props => {
    const { name, ...rest } = props;
    return (
        <span {...rest} style={{ color: '#1c84c6' }}>
            {name}(pending delete)
        </span>
    );
};

export default PendingDelete;
